module.exports = __webpack_public_path__ + "static/media/tutorial-banner.f13055c6.png";